export const SELECT_TAB = 'globalTabs/SELECT_TAB';
export const ADD_TAB = 'globalTabs/ADD_TAB';
export const ADD_OR_SELECT_TAB = 'globalTabs/ADD_OR_SELECT_TAB';
export const UPDATE_TAB = 'globalTabs/UPDATE_TAB';
export const SET_TAB_TITLE = 'globalTabs/SET_TAB_TITLE';
export const REFRESH_TAB = 'globalTabs/REFRESH_TAB';
export const CLOSE_TAB = 'globalTabs/CLOSE_TAB';
export const CLEAR_TABS = 'globalTabs/CLEAR_TABS';
export const SET_CONFIRM_REQUIRE = 'globalTabs/SET_CONFIRM_REQUIRE'
export const CONFIRM_TAB_CLOSE = 'globalTabs/CONFIRM_TAB_CLOSE';